import { render } from "./DefInput.vue?vue&type=template&id=5474ed3c&scoped=true"
import script from "./DefInput.vue?vue&type=script&lang=js"
export * from "./DefInput.vue?vue&type=script&lang=js"

import "./DefInput.vue?vue&type=style&index=0&id=5474ed3c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5474ed3c"]])

export default __exports__